import { render } from "./EventList.vue?vue&type=template&id=5360c5df"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"
script.render = render

export default script